'use client';

import { useState } from "react";
function useActionMenuItems(items) {
  const interactiveItems = items.reduce((agg, item, i) => {
    if (item.disabled) return agg;
    agg.push(i);
    return agg;
  }, []);
  const interactiveItemsLength = interactiveItems.length;
  const firstInteractiveIndex = interactiveItems[0];
  const lastInteractiveIndex = interactiveItems[interactiveItemsLength - 1];
  const [currentIndex, setCurrentIndex] = useState(
    firstInteractiveIndex
  );
  const nextItemIndex = currentIndex === lastInteractiveIndex ? firstInteractiveIndex : currentIndex + 1;
  const previousItemIndex = currentIndex === 0 ? lastInteractiveIndex : currentIndex - 1;
  return {
    currentIndex,
    setCurrentIndex,
    interactiveItemsLength,
    firstInteractiveIndex,
    nextItemIndex,
    previousItemIndex
  };
}
export {
  useActionMenuItems
};
